import { UserWorkspaceRole } from "../../common/userWorkspaceRoles";
import { UserRole } from "../../common/types/userEntityAssignment";

export const assignableWorkspaceRoles = [
    UserWorkspaceRole.ADMIN,
    UserWorkspaceRole.MEMBER,
    UserWorkspaceRole.ACCOUNTANT,
] as const;

export type AssignableWorkspaceRole = (typeof assignableWorkspaceRoles)[number];

export const workspaceLevelRoleDescription: Record<
    AssignableWorkspaceRole,
    string
> = {
    [UserWorkspaceRole.MEMBER]:
        "Can view transactions and reports, upload and download documents and add notes.",
    [UserWorkspaceRole.ADMIN]:
        "Can add accounts, manage members, and have full access to transactions and reports.",
    [UserWorkspaceRole.ACCOUNTANT]:
        "Can view reports, upload and download documents and invite other team members.",
};
export const assignableEntityRoles = [
    UserRole.ADMIN,
    UserRole.MEMBER,
    UserRole.ACCOUNTANT,
] as const;
export type AssignableEntityRole = (typeof assignableEntityRoles)[number];

export const entityLevelRoleDescription: Record<AssignableEntityRole, string> =
    {
        [UserRole.MEMBER]:
            "Can view transactions and reports, upload and download documents and add notes.",
        [UserRole.ADMIN]:
            "Can add accounts, manage members, and have full access to transactions and reports.",
        [UserRole.ACCOUNTANT]:
            "Can view transactions and reports, upload and download documents and add notes.",
    };
